import React, { createContext, useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { Autocomplete, Box, Button, Card, Chip, FormControl, FormControlLabel, FormLabel, Grid, IconButton, MenuItem, Modal, Radio, RadioGroup, Select, Stack, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { useForm, FormProvider } from 'react-hook-form';
import dayjs from 'dayjs';
// import { CouponServices } from './CouponServices';
import Swal from 'sweetalert2';
import NotificationForm from './NotificationForm';
import { NotificationServices } from './NotificationServices';
import { LocalStore } from '../../../storage/authStore';
// import ImageSection from './ImageSection';
// import CouponForm from './CouponForm';
// import isExpired from '../../../utils/checkCouponExpiry';


const NotificationDataContext = createContext();
const AddEditNotification = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const initialState = {
        gender: '',
        title: '',
        body: '',
        selectedCustomers: [],
        type: 'campaign',
        event: 'custom'
    }
    const [couponData, setCouponData] = useState(initialState);
    const CouponFormMethod = useForm({
        mode: 'onChange',
        defaultValues: couponData
    });
    const { control, watch, handleSubmit, setValue, formState: { isDirty, errors, dirtyFields }, reset } = CouponFormMethod;
    // const fetchCouponData = async () => {
    //     const response = await CouponServices.getCouponById(id);
    //     if (response.success == '1') {
    //         setCouponData(response.data);
    //         reset(response.data);
    //     } else {
    //         Swal.fire({
    //             icon: 'error',
    //             title: 'Error',
    //             text: response.message,
    //         });
    //     }
    // }
    // useEffect(() => {
    //     if (id > 0) {
    //         fetchCouponData();
    //     }
    // }, [id])

    const handleFormSubmit = async (data) => {
        console.log('Form data:', data);
        const arrayId = data.selectedCustomers;
        const convertIdObjectsToStrings = arrayId.map(item => String(item.id));
        const formatData = {
            customerIds: convertIdObjectsToStrings,
            title: data.title,
            body: data.body,
            type: 'campaign',
            event: 'custom',
            senderUserId: LocalStore.getCurrentUserDetails().id,
        }
        console.log("formatted Data:", formatData)
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: `You want to send notification?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            allowOutsideClick: false,
        })
        if (result.isConfirmed) {
            Swal.fire({
                title: 'Processing...',
                text: `Please wait while we Sending Notification`,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
            try {
                // if(id>0){
                //     const updateResponse = await NotificationServices.sendNotification(data);
                //     if (updateResponse.success == "1") {
                //         await Swal.fire({
                //             title: 'Success',
                //             text: 'Notification Sent successfully',
                //             icon: 'success',
                //             confirmButtonText: 'OK',
                //             timer: 1600,
                //         });

                //         navigate(`/marketing/coupon/view/${id}`);
                //     } else {
                //         await Swal.fire({
                //             title: 'Failed',
                //             text: updateResponse.message || 'Coupon Updation Failed',
                //             icon: 'error',
                //             confirmButtonText: 'OK',
                //         });
                //     }
                // }else{
                const createResponse = await NotificationServices.sendNotification(formatData);
                if (createResponse.success == "1") {
                    await Swal.fire({
                        title: 'Success',
                        text: 'Notification sent successfully',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        timer: 1600,
                    });
                    // navigate('/marketing/coupons');
                    reset(initialState);
                } else {
                    await Swal.fire({
                        title: 'Failed',
                        text: createResponse.message || 'Notification sending Failed',
                        icon: 'error',
                        confirmButtonText: 'OK',
                    });
                }
                // }
            } catch (error) {
                console.error('Error submitting coupon:', error);
            }
        }
    }

    return (
        <NotificationDataContext.Provider value={{ couponData, setCouponData }}>
            {/* <PageHeaderLayout headerTitle={id > 0 ? `Edit Coupon Detail's` : 'Add New Coupon'}>
                <Button variant='contained' onClick={() => navigate(-1)} size='small' startIcon={<ArrowBack />}>
                    Back
                </Button>
            </PageHeaderLayout> */}
            <Box sx={{ p: '.75% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >New Notification</Typography>
            </Box>
            <FormProvider {...CouponFormMethod}>
                <Box component={'form'} >
                    <Card sx={{ p: 2 }}>
                        <NotificationForm />
                        {/* {id>0 && isExpired(couponData.endDate) ? null: */}
                        <Grid item xs={12} sx={{ textAlign: "center" }}>
                            <Button disabled={!isDirty} size='small' variant='contained' color='primary' onClick={handleSubmit(handleFormSubmit)} sx={{ mt: '2%', fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                {id > 0 ? 'Update' : 'Save'}
                            </Button>
                        </Grid>
                        {/* } */}
                    </Card>
                </Box>
            </FormProvider>
        </NotificationDataContext.Provider>
    );
}

export default AddEditNotification;
export { NotificationDataContext };